import { useQuery } from '@tanstack/react-query';
import { GeogroupService } from '../services';
import { queryKeys } from './query-keys';
function useChallengeLeaderboardQuery(challengeId, params) {
  return useQuery({
    queryKey: queryKeys.challengeLeaderboard.detail(challengeId, params),
    queryFn: () => GeogroupService.getChallengeLeaderboard(challengeId, params),
    enabled: challengeId !== undefined,
    staleTime: Infinity
  });
}
export default useChallengeLeaderboardQuery;